import * as React from "react";
import Component from "../../AbstractComponent";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import ActivityTemplateUpdateWillMount from "../../../Middleware/Middlewares/ActivityTemplateUpdateWillMount";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { ActivityTemplateInterface } from "Casadesk/Entity/Entities/Activity/ActivityTemplateInterface";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { CoachDialogNewExecutor } from "../../Partials/Dialog/CoachDialogNewExecutor";

import IconButton from '@material-ui/core/IconButton';
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

class ActivityTemplateUpdate extends Component {
  protected activityTemplate: ActivityTemplateInterface;
  public instructionsField;
  protected person: PersonInterface;
  protected timerId: any;

  public state = {
    name: "",
    hasModifiedData: false,
    openLeavePrompt: false,
    taskTemplates: [],
    activeTemplateArrayPosition: 0,
    taskToDeleteId: 0,
    activeTemplate: null,
    isDeleteTaskPopupOpen: false,
    errorTemplates: [],
    isSaving: false,
    selectedTaskTemplate: null,
    openPreTaskExecutorCoachDialog: false,
    executorType: "person",
    executorTypeСhoose: true,
    openTaskExecutorCoachDialog: false,
    isProcessingTask: false
  };

  protected middlewares: MiddlewareInterface[] = [
    ActivityTemplateUpdateWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);
  }

  public createTaskTemplate = () => {
    const taskTemplate = {
      name: this.trans("new-task"),
      details: "",
      executorId: null,
      daysToExecute: 0,
      activityTemplateId: this.activityTemplate.id
    };

    const taskTemplates = [...this.state.taskTemplates];
    const previousTaskTemplate = taskTemplates[taskTemplates.length - 1];
    const previousTaskTemplateName = previousTaskTemplate ? previousTaskTemplate.data.name : "";
    const previousTaskTemplateNumber = parseInt(previousTaskTemplateName.replace(this.trans("new-task"), ""));
    let newTaskTemplateName = `${this.trans("new-task")} ${previousTaskTemplateNumber + 1}`;

    if (previousTaskTemplateName === this.trans("new-task")) {
      newTaskTemplateName = `${this.trans("new-task")} 2`;
      taskTemplate.name = newTaskTemplateName;
    }

    if (previousTaskTemplateName.includes(this.trans("new-task"))) {
      taskTemplate.name = newTaskTemplateName;
    }

    this.setState({
      isProcessingTask: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_TASK_TEMPLATE_CREATE_START,
        payload: {
          ...taskTemplate
        },
        onSuccess: taskTemplate => {
          const taskTemplates = [...this.state.taskTemplates];

          taskTemplates.push(taskTemplate);

          this.setState({
            taskTemplates: [...taskTemplates],
            activeTemplate: {...taskTemplate},
            activeTemplateArrayPosition: taskTemplates.length - 1,
            isProcessingTask: false,
            hasModifiedData: true
          }, () => {
            if(this.instructionsField){
              this.instructionsField.focus();
            }
          });
        },
        onError: () => {
          this.setState({
            isProcessingTask: false
          });
        }
      });
    })
  }

  public updateTaskTemplate = () => {
    if(!this.state.activeTemplate.data.name) {
      const errorTemplates = [];
      errorTemplates.push(this.state.activeTemplateArrayPosition);

      return this.setState({
        errorTemplates: [...errorTemplates]
      });
    }

    this.setState({
      isProcessingTask: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_TASK_TEMPLATE_UPDATE_START,
        payload: {
          name: this.state.activeTemplate.data.name,
          details: this.state.activeTemplate.data.details,
          executorId: this.state.activeTemplate.data.executorId,
          daysToExecute: this.state.activeTemplate.data.daysToExecute !== "" ? this.state.activeTemplate.data.daysToExecute : null,
          activityTemplateId: this.activityTemplate.id,
          id: this.state.activeTemplate.data.id
        },
        onSuccess: (taskTemplate) => {
          const templates = [...this.state.taskTemplates];
          templates[this.state.activeTemplateArrayPosition] = taskTemplate;

          this.setState({
            taskTemplates: [...templates],
            // activeTemplate: {...taskTemplate},
            isProcessingTask: false,
          });
        },
        onError: () => {
          this.setState({
            isProcessingTask: false
          });
        }
      });
    })
  }

  public save = () => {
    if (this.state.errorTemplates.length > 0) {
      return;
    }

    if(!this.isUserHasAccess()) {
      return this.redirectBack();
    }

    if(!this.state.hasModifiedData) {
      return this.redirectBack();
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_ACTIVITY_TEMPLATE_UPDATE_START,
        payload: {
          id: this.activityTemplate.id,
          name: this.state.name
        },
        onSuccess: () => {
          this.redirectBack();
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public selectPerson = (person: PersonInterface, isManuallySelected: boolean): void => {
    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateArrayPosition]};
    const data = {...template.data}
    data.executorId = person.id;
    template.data = data;
    templates[this.state.activeTemplateArrayPosition] = {...template};

    this.setState({
      activeTemplate: {...template},
      taskTemplates: [...templates],
      hasModifiedData: isManuallySelected
    }, this.updateTaskTemplate);
  }

  public clearPerson = () => {
    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateArrayPosition]};
    const data = {...template.data}
    data.executorId = null;
    template.data = data;
    templates[this.state.activeTemplateArrayPosition] = {...template}

    this.setState({
      activeTemplate: {...template},
      taskTemplates: [...templates],
      hasModifiedData: true
    }, this.updateTaskTemplate);
  }

  public changeDays = (event) => {
    const days = Number.parseInt(event.target.value);

    this.setState({
      daysToExecute: days,
      hasModifiedData: true
    });
  }

  public setActivityTemplateName = (event) => {
    let name = event.target.value;

    this.setState({
      name: name,
      hasModifiedData: true
    });
  }

  public setTemplateName = (event) => {
    const name = event.target.value;

    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateArrayPosition]};
    const data = {...template.data}
    data.name = name;
    template.data = data;
    templates[this.state.activeTemplateArrayPosition] = {...template}

    const errorTemplates = [...this.state.errorTemplates];
    errorTemplates.forEach((id, index) => {
      if (id === this.state.activeTemplateArrayPosition) {
        errorTemplates.splice(index, 1);
      }
    });

    this.setState({
      activeTemplate: {...template},
      taskTemplates: [...templates],
      errorTemplates: [...errorTemplates],
      hasModifiedData: true
    });
  }

  public setTemplateDetails = (event) => {
    const details = event.target.value;

    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateArrayPosition]};
    const data = {...template.data}
    data.details = details;
    template.data = data;
    templates[this.state.activeTemplateArrayPosition] = {...template}

    this.setState({
      activeTemplate: {...template},
      taskTemplates: [...templates],
      hasModifiedData: true
    });
  }

  public setTemplateDays = (event) => {
    const days = Number.parseInt(event.target.value);
    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateArrayPosition]};
    const data = {...template.data}
    data.daysToExecute = days;
    template.data = {...data};
    templates[this.state.activeTemplateArrayPosition] = {...template}

    this.setState({
      activeTemplate: {...template},
      taskTemplates: [...templates],
      hasModifiedData: true
    });
  }

  public choosedTaskToDelete = (templateId: number) => {
    const templates = [...this.state.taskTemplates];
    const template = templates.splice(templateId, 1)[0];

    this.setState({
      isDeleteTaskPopupOpen: true,
      taskToDeleteId: templateId,
      selectedTaskTemplate: template
    })
  }

  public deleteTask(templateId: number) {
    this.props.dispatch({
      type: Constants.GLOBAL_TASK_TEMPLATE_DELETE_START,
      payload: {
        taskTemplate: this.state.selectedTaskTemplate
      },
      onSuccess: () => {
        const templates = [...this.state.taskTemplates];
        templates.splice(templateId, 1)[0];
        const activeTemplate = {...templates[0]} || null;

        this.setState({
          taskTemplates: [...templates],
          activeTemplateArrayPosition: 0,
          activeTemplate: {...activeTemplate},
          errorTemplates: [],
          hasModifiedData: true
        });
      }
    });
  }

  public onBlur = () => {
    if (this.state.name === "") {
      this.setState({
        name: this.activityTemplate.name
      });
    }
  }

  public getCoachContent = () => {
    return (
      <div>
        <div>
          {this.trans("coach/executor-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.executorType}
            onChange={this.chooseExecutorType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="user"
              label={this.trans("coach/executor-radiobutton/user")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/executor-radiobutton/person")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/executor-radiobutton/company")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/executor-radiobutton/department")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
          </RadioGroup>
        </div>
        {/* <div>
          {this.trans("coach/executor-scenario/company-step/first-info2")}
        </div> */}
      </div>
    )
  }

  public chooseExecutorType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      executorType: choice,
      executorTypeСhoose: true
    });
  }

  public onCloseCoach = () => {
    this.setState({
      openPreTaskExecutorCoachDialog: false,
      executorType: "person",
      // executorTypeСhoose: true,
      openTaskExecutorCoachDialog: false
    })
  }

  public setExecutorFromCoach = (executor, isManuallySelected) => {
    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateArrayPosition]};
    const data = {...template.data}
    data.executorId = executor.id;
    template.data = data;
    templates[this.state.activeTemplateArrayPosition] = {...template};

    this.setState({
      activeTemplate: {...template},
      taskTemplates: [...templates],
      hasModifiedData: isManuallySelected
    }, this.updateTaskTemplate);
  }

  public openFirstStep = () => {
    this.setState({
      executorType: this.state.executorTypeСhoose ? this.state.executorType : "person",
      openPreTaskExecutorCoachDialog: true,
      openTaskExecutorCoachDialog: false
    })
  }

  public openTaskExecutorCoach = () => {
    if(this.state.executorType !== "user" || this.person.role && this.person.role.getRoleId() === 6) {
      this.setState({
        openPreTaskExecutorCoachDialog: false,
        openTaskExecutorCoachDialog: true
      })
    } else {
        this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("coach/executor-scenario/user-step/first-error"),
            type: "error"
          }
        });
        return;
    }
  }

  public render() {
    const rightBlockWidth = "340px";
    const readOnly = !this.isUserHasAccess();

    return (
      <div className="state-app">
        <div className="box component-activity full-width box-full has-details-page-header">
          <div className="component-header has-back-button align-center">
            <div className="back-arrow-wrapper" onClick={this.redirectBack}>
              <div className="icon icon-ic-arrow-back icon-color"></div>
            </div>
            <h1>{this.trans("activity-template")}</h1>
            <div className="button-container">
              <Button
                variant="contained"
                color="primary"
                onClick={this.save}
                disabled={this.state.isSaving}
              >
                {this.state.hasModifiedData ? this.trans("button-save") : this.trans("button-done")}
              </Button>
            </div>
          </div>

          <div className="component-wrapper no-margin-top">
            <div className="component">
              <Card className="card" style={{padding: "20px"}}>
                {readOnly && <div style={{color: "rgb(0, 188, 212)", fontSize: "14px", margin: "0px 0px 10px"}}>{this.trans("preprocess/cantcreateactivitytemplate-info")}</div>}
                <p style={{color: "#333", margin: "0 0 10px 0"}}>
                  {this.trans("determine-name-for-activity")}
                </p>
                <div className="hint-styles-dialog" style={{color: "#333", margin: "0px"}}>
                  {this.trans("determine-name-for-activity-2")}
                </div>
              </Card>
            </div>
          </div>

          <div className="component-wrapper no-margin-top">
            <div className="component">
              <Card className="card" style={{padding: "20px"}}>
                <div style={{maxWidth: "270px"}}>
                  <TextField
                    autoComplete="off"
                    id="activityTemplateName"
                    name="activityTemplateName"
                    className="form-element full-size scroll-to-name"
                    type="text"
                    label={this.trans("page/activity-field/name-label")}
                    value={this.state.name}
                    onChange={this.setActivityTemplateName}
                    variant="standard"
                    disabled={readOnly}
                    onBlur={this.onBlur}
                    error={!!this.getErrorFor("name")}
                  />
                  {!!this.getErrorFor("name") && <div className="component-error-text">{this.getErrorFor("name")}</div>}
                </div>
              </Card>
            </div>
          </div>

          <div className="component-wrapper">
            <Card className="card no-padding">
              <div className="label-container">
                <h3 className="card-title">
                  {this.trans("tasks")}
                </h3>
                <Button
                  color="primary"
                  onClick={this.createTaskTemplate}
                  className="add-task"
                  disabled={readOnly || this.state.isProcessingTask}
                  >
                  {this.trans("button-add-task")}
                </Button>
              </div>
              <div className="task-tempalte-wrapper" style={{display: "flex"}}>
                <div className="left-block"
                  style={{
                    minHeight: "300px",
                    width: "30%",
                    borderRight: "1px solid rgba(0, 0, 0, 0.1)"
                  }}
                >
                  {
                    this.state.taskTemplates.length === 0 && (
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      >
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "8px"}}>
                          <div className="icon icon-ic-task" style={{color: "#dcdbdc"}}></div>
                        </div>
                        <div style={{fontSize: "22px", fontWeight: "bold", color: "#dcdbdc", marginBottom: "8px"}}>{this.trans("no-tasks-created")}</div>
                      </div>
                    )
                  }
                  {
                    this.state.taskTemplates.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: "flex-start"
                        }}
                      >
                        {
                          this.state.taskTemplates
                          .filter(taskTemplate => taskTemplate.data.removed === false)
                          .map((taskTemplate, key: number) => {
                            return (
                              <div key={key} className={this.state.activeTemplateArrayPosition === key ? "with-active-gray-background" : "with-active-white-background"}
                                style={{
                                  borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  cursor: "pointer",
                                  backgroundColor: this.state.errorTemplates.some(index => index === key) ? "#ffa4a4" : ""
                                }}
                                onClick={() => {
                                  this.timerId = setInterval(() => {
                                    if (this.state.isProcessingTask) {
                                      return;
                                    } else {
                                      clearInterval(this.timerId);

                                      this.setState({
                                        activeTemplate: {...taskTemplate},
                                        activeTemplateArrayPosition: key
                                      });
                                    }
                                  }, 100);
                                }}
                              >
                                <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                  <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px"}}>
                                    <div className="icon icon-ic-task" style={{color: "#dcdbdc"}}></div>
                                  </div>
                                  <div style={{fontSize: "14px", color: "#404040", lineHeight: "24px"}}>{taskTemplate.data.name}</div>
                                </div>
                                <div className="">
                                  <div
                                    onClick={() => { if(!readOnly){this.choosedTaskToDelete(key)}}}
                                    style={{display: "flex", alignItems: "center", justifyContent: "center"}}
                                  >
                                    <IconButton disabled={readOnly} aria-label="Delete" className="icon-button-wrapper">
                                      <div className="icon icon-ic-remove"></div>
                                    </IconButton>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        }
                      </div>
                    )
                  }
                </div>
                <div className="right-block" style={{paddingLeft: "20px"}}>
                  {this.state.taskTemplates.length > 0 && (
                    <div style={{width: rightBlockWidth}}>
                      <TextField
                        autoComplete="off"
                        className="form-element full-size"
                        type="text"
                        label={this.trans("label-description")}
                        value={this.state.activeTemplate ? this.state.activeTemplate.data.name : ""}
                        onChange={this.setTemplateName}
                        onBlur={this.updateTaskTemplate}
                        autoFocus={true}
                        inputRef={(input) => { this.instructionsField = input; }}
                        disabled={readOnly}
                        variant="standard"
                        multiline
                        rowsMax="25"
                        rows="1"
                        error={this.state.errorTemplates.some(index => index === this.state.activeTemplateArrayPosition) && !!this.trans("this-field-is-required")}
                      />
                      {this.state.errorTemplates.some(index => index === this.state.activeTemplateArrayPosition) && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

                      <div style={{margin: "-10px 0"}}>
                        <PersonLookup
                          {...this.props}
                          isInlineBlock={true}
                          ref="PersonLookup"
                          width={rightBlockWidth}
                          floatingLabelText={this.trans("to-do-by") + this.trans("field/optional")}
                          labelText={this.trans("to-do-by") + this.trans("field/optional")}
                          onSelect={this.selectPerson}
                          onClear={this.clearPerson}
                          onBlur={this.updateTaskTemplate}
                          autoSelectId={this.state.activeTemplate.data.executorId}
                          buttonLabel={this.trans("button-add-executor")}
                          noResultText={this.trans("textfield-no-executor-found-click-add")}
                          templateFor={"executor"}
                          includeUsers={true}
                          hideClickThroughLink={true}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "activityTemplateUpdate", "executor")}
                          disabled={readOnly}
                          shouldOpenCoachModal={true}
                          openTaskExecutorCoachDialog={() => this.setState({openPreTaskExecutorCoachDialog: true})}
                        />
                      </div>

                      <TextField
                        autoComplete="off"
                        className="form-element"
                        label={this.trans("days-to-execute") + this.trans("field/optional")}
                        value={this.state.activeTemplate && this.state.activeTemplate.data.daysToExecute !== null ? this.state.activeTemplate.data.daysToExecute : ""}
                        onChange={this.setTemplateDays}
                        type="number"
                        onBlur={this.updateTaskTemplate}
                        style={{width: rightBlockWidth}}
                        disabled={readOnly}
                        variant="standard"
                        error={this.getErrorFor("daysToExecute")}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Card>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("delete-task")}
          content={this.trans("you-are-about-to-delete-task", {name: this.state.selectedTaskTemplate && this.state.selectedTaskTemplate.name ? this.state.selectedTaskTemplate.name : ""})}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteTaskPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteTaskPopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteTaskPopupOpen: false }); this.deleteTask(this.state.taskToDeleteId) }}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("coach/executor-title")}
          content={this.getCoachContent()}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("coach/propertyowner-button/next")}
          openLeavePrompt={this.state.openPreTaskExecutorCoachDialog}
          prioritizeClosing={true}
          innerDialogClasses="dialog-assistant coach-executor"
          onDiscard={() => {
            this.setState({
              openPreTaskExecutorCoachDialog: false,
              // ownerType: "",
              // ownerTypeСhose: false
            });
          }}
          onSave={this.openTaskExecutorCoach}
          // diableContinueButton={!this.state.ownerTypeСhose}
        />

        <CoachDialogNewExecutor
          {...this.props}
          openTaskExecutorCoachDialog={this.state.openTaskExecutorCoachDialog}
          type={this.state.executorType}
          setExecutor={this.setExecutorFromCoach}
          openFirstStep={this.openFirstStep}
          onCloseCoach={this.onCloseCoach}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.companyCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  ActivityTemplateUpdate
);
